import { call, put, select } from 'redux-saga/effects'

import Zoid from 'common/modules/zoid'
import logger from 'common/logger'

import { creators } from '../../actions'

import picoPromptShown from './pico.prompt.shown'
import picoReady from './pico.ready'
import picoLoaded from './pico.loaded'
import picoUserRegistered from './pico.user.registered'
import picoUserAuthenticated from './pico.user.authenticated'
import picoPaymentMethodAdded from './pico.paymentMethod.added'
import picoPaymentPaid from './pico.payment.paid'
import picoInit from './pico.init'

const picoEvents = [
    picoPromptShown,
    picoReady,
    picoLoaded,
    picoUserRegistered,
    picoUserAuthenticated,
    picoPaymentMethodAdded,
    picoPaymentPaid,
    picoInit,
]

const lifecycleEvents = {}

picoEvents.forEach((picoEvent) => {
    Object.keys(picoEvent).forEach((key) => {
        if (!Array.isArray(picoEvent[key])) {
            return
        }

        if (!lifecycleEvents[key]) {
            lifecycleEvents[key] = []
        }

        lifecycleEvents[key] = [
            ...lifecycleEvents[key],
            ...picoEvent[key],
        ]
    })
})

export const lifecycleActions = Object.keys(lifecycleEvents)

export default function* watchLifecycleEvents(action) {
    const { type } = action
    const { lifecycleEvent } = yield select(Zoid.selectors.getXprops)

    const events = lifecycleEvents[type] || []

    let i = 0

    while (i < events.length) {
        const payload = events[i]
        const { event, data } = payload

        try {
            const lifecycleEventData = yield call(data, action)

            if (lifecycleEventData) {
                yield put(
                    yield call(
                        creators.addEvent,
                        {
                            payload: {
                                ...payload,
                                data: lifecycleEventData,
                            },
                        },
                    ),
                )

                yield call(lifecycleEvent, event, lifecycleEventData)
            }
        } catch (error) {
            logger.error(error.message, error)
        }

        i += 1
    }
}
